export default {
    name: 'Modal',
    data () {
        return {
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/modal/modal.js